import React from 'react';
export function Footer() {
  return <footer className="text-xs text-center p-4 text-gray-500 bg-[#FAF8F6] border-t border-red-100" data-id="element-13">
      For educational use by qualified practitioners. Always individualize
      treatment based on full TCM pattern differentiation.
    </footer>;
}